import { render, staticRenderFns } from "./ExtensionAndEndorsementsPro.vue?vue&type=template&id=058077c4&scoped=true&"
import script from "./ExtensionAndEndorsementsPro.vue?vue&type=script&lang=js&"
export * from "./ExtensionAndEndorsementsPro.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionAndEndorsementsPro.vue?vue&type=style&index=0&id=058077c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058077c4",
  null
  
)

export default component.exports